import React from "react";
import { connect } from "react-redux";
import { getBestPerformanceList } from "../../services/admin/action";
import moment from "moment";
import DatePicker from "react-datepicker";
import Pagination  from '../common/pagination'

class BestPerformance extends React.Component{

    constructor(props) {
        super(props)
        let date = new Date();
        this.state = {
            access_token: "",
            employPerformanceList: [],
            pageOfItems:[],
            startDate:new Date(date.getFullYear(), date.getMonth(), 1),
            endDate: new Date(date.getFullYear(), date.getMonth() + 1, 0),
        }
    }


    searchDetails = () =>{
        let access_token = this.props.loginDetails;
       // let userType = this.props.profileDetails.commonUser.userType

         this.setState({
            access_token,

        })
       
        let updateDate = moment(this.state.startDate).format('YYYY-MM-DD HH:mm:ss')
       let updateDateEnd = moment(this.state.endDate).format('YYYY-MM-DD HH:mm:ss')
 
      let status = "Completed"
        
        this.props.getBestPerformanceList(access_token,updateDate,updateDateEnd,status);

    }

    componentDidMount() {
     this.searchDetails();
    }

    onChangePage = (pageOfItems) => {
        // update state with new page of items
        this.setState({ pageOfItems: pageOfItems });
    }

    componentWillReceiveProps = nextProps => {
      if(nextProps.getBestPerformanceStatus){
        let data = nextProps.getBestPerformanceDetails.employeePerformance;
        this.setState({
            employPerformanceList: data,
        })
      }else{
        this.setState({
            employPerformanceList: [],
        })
      }  
    }
    chageStartDate = (date) => {
        this.setState({
            startDate: date,
        })
    }
    changeEndDate = (date) => {
        this.setState({
            endDate: date,
        })
    }

    render(){

         const {

            startDate,
            endDate,
     
        } = this.state
        return(
            <React.Fragment>

<div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="form-group r-form">
                        <label for="dob">StartDate</label><sup>*</sup>
                        <DatePicker selected={startDate}  class="form-control r-txt" id="dob"
                            type="text" placeholderText="DOB" name="dateOfBirth"
                            onChange={this.chageStartDate} peekNextMonth
                            showMonthDropdown
                            maxDate={new Date()}
                            showYearDropdown
                            dropdownMode="select" 
                            autocomplete="false"/>
                        <div class="r-icon">
                            <i class="fa fa-calendar" aria-hidden="true"></i>
                        </div>
                    </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                   

                    <div class="form-group r-form">
                        <label for="dob">EndDate</label><sup>*</sup>
                        <DatePicker selected={endDate} class="form-control r-txt" id="dob"
                            type="text" placeholderText="DOB" name="dateOfBirth"
                            onChange={this.changeEndDate} peekNextMonth
                            minDate={this.state.startDate}   maxDate={new Date()}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select" 
                            autocomplete="false"/>
                        <div class="r-icon">
                            <i class="fa fa-calendar" aria-hidden="true"></i>
                        </div>
                    </div>
                    </div>
                </div>
<div class="row">
                <div class="col-lg-12">
                   <div>

                       <div className="form-group pull-right">
                           <button onClick={this.searchDetails} type="button" className="btnDefault marginTop20 right-no">Search</button>
                       </div>
                   </div>

               </div></div>

            <div className="row tab-pane" id="bestperformance">

      

                {/* <div className="row"> */}

                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  
                    <div className="table-responsive">
                        <table className="table commonTable">
                            <thead>
                                <tr>
                                     <th>Requests Completed</th>
                                    <th>Name</th>
                                    {/* <th>Email</th>
                                    <th>Mobile</th>
                                    <th>Actions</th> */}
                                </tr>
                            </thead>
                           
                            <tbody>
                            {this.state.pageOfItems.length > 0 ?
                                this.state.pageOfItems.map((employe, id) => {
                                    return (
                                        <tr key={id}> 
                                            <td>{employe.count}</td>
                                            <td>{employe.employeeName}</td>
                                             
                                        </tr>
                                    )
                                }) : <tr style={{background:"transparent"}}><td colspan="6"><img alt="" src="images/no-record-found.png" width="180px" style={{opacity:"0.6"}}/></td></tr>
                            }
                             

                            </tbody>
                        </table>
                    </div>
                    <Pagination items={this.state.employPerformanceList}   onChangePage={this.onChangePage} />
     
                  

                </div>
            </div>


            

        </React.Fragment>

        )
    }

}


const mapStateToProps = state => ({
    loginDetails: state.commonReducer.loginDetails,
    profileDetails: state.commonReducer.profileDetails,
    getBestPerformanceDetails: state.adminReducer.getBestPerformanceDetails,
    getBestPerformanceStatus: state.adminReducer.getBestPerformanceStatus
});

const mapDispatchToProps = dispatch => ({
    getBestPerformanceList: (token,updateDate,updateDateEnd,status) => dispatch(getBestPerformanceList(token,updateDate,updateDateEnd,status)),
    
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BestPerformance);